import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';
import ApplyThresholdIcon from '@icons/noc/apply-threshold.svg';

export const HeaderWrapper = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;

  button {
    flex: 0 0 32px;
  }
`;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ApplyIcon = styled(ApplyThresholdIcon)`
  font-size: 25px;
`;

export const MetricTitle = styled(EllipsisTooltip)`
  width: auto;
`;
